import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { useAuth } from './auth';

const PrivateRoute = ({ children, owner }) => {
  const { user, userType, loading } = useAuth();
  const params = useParams();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', backgroundColor: 'var(--color-background, #F7F9FC)' }}>
        <div
          aria-label="Loading"
          role="status"
          style={{ width: 32, height: 32, border: '3px solid var(--color-border, #e2e8f0)', borderTopColor: 'var(--color-primary, #333)', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }}
        />
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  if (owner === 'company' && !(userType === 'Company' && user.companyUser === params.companyUser)) {
    return <Navigate to="/" replace />;
  }

  if (owner === 'user' && !(userType !== 'Company' && user.user === params.user)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default PrivateRoute;
